import React from 'react';
import styled from 'styled-components';

const InfoItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  width: 100%;
  align-items: flex-start;
  justify-content: flex-start;
`;

const Label = styled.div`
  color: #161616;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 160%;
  letter-spacing: -0.32px;
`;

const Value = styled.div`
  color: #666;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 160%;
  letter-spacing: -0.32px;
`;

export default function InfoItem({
  label,
  value
}: {
  label: string;
  value: string;
}) {
  return (
    <InfoItemContainer>
      <Label>{label}</Label>
      <Value>{value}</Value>
    </InfoItemContainer>
  );
}
